import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NextpageModule } from '../nextpage/nextpage.module';
import { MatListModule } from '@angular/material/list';
import { SearchModule } from '../search/search.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatSidenavModule } from '@angular/material/sidenav';
import { API_BASE_URL, EsraPipingAPIClient } from '../shared/models/autogenerated-piping';
import { environment } from 'src/environments/environment';
import { CreateRevisionComponent } from './revisions/create-revision/create-revision.component';
import { CreateReleaseWizardComponent } from './releases/create-release-wizard/create-release-wizard.component';
import { TechModCreateComponent } from './techmod-create/techmod-create.component';
import { ReleasesAndRevisionsComponent } from './piping-releases-and-revisions/piping-releases-and-revisions.component';
import { PipingRevisionStatusPipe } from '../revisions/pipes/piping-revision-status.pipe';
import { Esra1CompatibilityComponent } from './esra1-compatibility/esra1-compatibility.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RevisionsTabComponent } from './piping-releases-and-revisions/revisions-tab/revisions-tab.component';
import { ReleasesTabComponent } from './piping-releases-and-revisions/releases-tab/releases-tab.component';
import { ReleaseDetailsComponent } from './piping-releases-and-revisions/release-details/release-details.component';
import { RestoreDraftDialogComponent } from './piping-releases-and-revisions/release-details/restore-draft-dialog/restore-draft-dialog.component';
import { ValveReleaseDropdownComponent } from './releases/valve-release-dropdown/valve-release-dropdown.component';
import { AddClassToReleaseDialogComponent } from './piping-releases-and-revisions/release-details/add-class-to-release-dialog/add-class-to-release-dialog.component';
import { ReleaseRowInfoPanelComponent } from './piping-releases-and-revisions/release-details/release-row-info-panel/release-row-info-panel.component';
import { ReleaseRolesTabComponent } from './piping-releases-and-revisions/release-details/release-roles-tab/release-roles-tab.component';
import { ReleaseFinalChecksComponent } from './release-final-checks/release-final-checks.component';
import { ReplaceComponentDialogComponent } from './release-final-checks/replace-component-dialog/replace-component-dialog.component';
import { ReleaseCommentsTabComponent } from './piping-releases-and-revisions/release-details/release-comments-tab/release-comments-tab.component';
import { BuPdfBulkUploadComponent } from './bu-pdf-bulk-upload/bu-pdf-bulk-upload.component';
import { BuPdfBulkUploadPreviewComponent } from './bu-pdf-bulk-upload/bu-pdf-bulk-upload-preview/bu-pdf-bulk-upload-preview.component';
import { BuPdfRowPickerDialogComponent } from './bu-pdf-bulk-upload/bu-pdf-row-picker-dialog/bu-pdf-row-picker-dialog.component';
import { BuPdfFilePickerDialogComponent } from './bu-pdf-bulk-upload/bu-pdf-file-picker-dialog/bu-pdf-file-picker-dialog.component';

@NgModule({
  declarations: [
    ReleasesAndRevisionsComponent,
    RevisionsTabComponent,
    ReleasesTabComponent,
    ReleaseDetailsComponent,
    ReleaseRolesTabComponent,
    ReleaseRowInfoPanelComponent,
    AddClassToReleaseDialogComponent,
    RestoreDraftDialogComponent,
    CreateRevisionComponent,
    CreateReleaseWizardComponent,
    TechModCreateComponent,
    PipingRevisionStatusPipe,
    Esra1CompatibilityComponent,
    ValveReleaseDropdownComponent,
    ReleaseFinalChecksComponent,
    ReplaceComponentDialogComponent,
    ReleaseCommentsTabComponent,
    BuPdfBulkUploadComponent,
    BuPdfBulkUploadPreviewComponent,
    BuPdfRowPickerDialogComponent,
    BuPdfFilePickerDialogComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NextpageModule,
    OverlayModule,
    RouterModule,
    SearchModule,
    SharedModule,
    MatSortModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCardModule,
    MatChipsModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatExpansionModule,
    MatTableModule,
    MatCardModule
  ],
  providers:[
    { provide: API_BASE_URL, useValue: environment.pipingApiEndpoint },
    EsraPipingAPIClient
  ]
})
export class PipingValvesModule {}
